import React, { useEffect, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';


const LocationViewFromMail = () => {
  const { locId } = useParams();
  const navigate = useNavigate();
  localStorage.setItem('selectedLocation', locId);

  useEffect(() => {
    navigate('/timeline');
  }, []);

  return (
    <>
    </>
  );
};



export default LocationViewFromMail;
